import { TOGGLE_MOBILE_DRAWER_LEFT_SIDEBAR } from './constants';

export const initialState = {
  isShowDrawer: false,
};

function DemoHomePageContainerReducer(state = initialState, action) {
  switch (action.type) {
    case TOGGLE_MOBILE_DRAWER_LEFT_SIDEBAR:
      return {
        ...state,
        isShowDrawer: action.payload.isShowDrawer,
      };
    default:
      return state;
  }
}

export default DemoHomePageContainerReducer;
